module.exports = __webpack_public_path__ + "static/media/saffron3.508fd01e.jpg";